import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {
    name: '',
    email: '',
    phone: '',
    address: '',
    gst_number: '',
    contact_type: '',
    customer_id: '',
    order_date: new Date(),
    delivery_date: null,
    advance_amount: '',
    payments: [],
    pending: '0.00',
    payment_method: '',
    order_type: 'invoice',
    branch_id: '',
    delivery_address: '',
    packing_charges: 0,
    salesman_id: '',
    utensils_charges: 0,
    // DISCOUNT FIELDS - FIXED & DEFAULTED
    discount_type: 'fixed',        // DEFAULT: Fixed Amount
    discount_percentage: 0,
    discount_fixed: 0,
    delivery_type: '',
    payment_date: null,
    invoice_number: '',
    branch_code: '',
    notes: '',
    order_image: null,
    status: 'order_placed',
    quotation_tax_percentage: 0,
    carton_box_count: '',
  },
  errors: {},
  sameAsAddress: true,
  customers: [],
  branches: [],
  salesman: [],
  selectedCustomerId: '',
  selectedCustomer: null,
  mode: 'existing',
  submitting: false,
  totals: {
    subtotal: 0,
    taxAmount: 0,
    total: 0,
    discount: 0,
    grandTotal: 0,
  },
  invoiceStatus: { exists: null, message: '' },
  openModal: false,
  openAdvance: false,
  openOrder: false,
  openDelivery: false,
  loading: false,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setSameAsAddress: (state, action) => {
      state.sameAsAddress = action.payload;
      if (action.payload && state.formData.address) {
        state.formData.delivery_address = state.formData.address;
        state.errors.delivery_address = '';
      }
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
    setSalesMan: (state, action) => {
      state.salesman = action.payload;
    },
    setSelectedCustomerId: (state, action) => {
      state.selectedCustomerId = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setSubmitting: (state, action) => {
      state.submitting = action.payload;
    },
    setTotals: (state, action) => {
      state.totals = { ...state.totals, ...action.payload };
    },
    setInvoiceStatus: (state, action) => {
      state.invoiceStatus = action.payload;
    },
    setOpenModal: (state, action) => {
      state.openModal = action.payload;
    },
    setOpenAdvance: (state, action) => {
      state.openAdvance = action.payload;
    },
    setOpenOrder: (state, action) => {
      state.openOrder = action.payload;
    },
    setOpenDelivery: (state, action) => {
      state.openDelivery = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetOrderState: () => initialState,
  },
});

export const {
  setFormData,
  setErrors,
  setSameAsAddress,
  setCustomers,
  setBranches,
  setSalesMan,
  setSelectedCustomerId,
  setSelectedCustomer,
  setMode,
  setSubmitting,
  setTotals,
  setInvoiceStatus,
  setOpenModal,
  setOpenAdvance,
  setOpenOrder,
  setOpenDelivery,
  setLoading,
  resetOrderState,
} = orderSlice.actions;

export default orderSlice.reducer;


// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   formData: {
//     name: '',
//     email: '',
//     phone: '',
//     address: '',
//     gst_number: '',
//     contact_type: '',
//     order_date: new Date(),
//     delivery_date: null,
//     advance_amount: '',
//     pending: '',
//     payment_method: '',
//     order_type: 'quotation',
//     branch_id: '',
//     delivery_address: '',
//     packing_charges: '',
//     salesman_name: '',
//     discount_percentage: '',
//     delivery_type: '',
//     payment_date: new Date(),
//     invoice_number: '',
//     branch_code: '',
//     notes: '',
//     status: 'order_placed',
//   },
//   errors: {},
//   sameAsAddress: true,
//   customers: [],
//   branches: [],
//   selectedCustomerId: '',
//   selectedCustomer: null,
//   mode: '',
//   submitting: false,
//   totals: { subtotal: 0, taxAmount: 0, total: 0 },
//   invoiceStatus: { exists: null, message: '' },
//   openModal: false,
//   openAdvance: false,
//   openOrder: false,
//   openDelivery: false,
//   loading: false,
// };

// const orderSlice = createSlice({
//   name: 'order',
//   initialState,
//   reducers: {
//     setFormData: (state, action) => {
//       state.formData = { ...state.formData, ...action.payload };
//     },
//     setErrors: (state, action) => {
//       state.errors = action.payload;
//     },
//     setSameAsAddress: (state, action) => {
//       state.sameAsAddress = action.payload;
//       if (action.payload) {
//         state.formData.delivery_address = state.formData.address || '';
//         state.errors.delivery_address = '';
//       }
//     },
//     setCustomers: (state, action) => {
//       state.customers = action.payload;
//     },
//     setBranches: (state, action) => {
//       state.branches = action.payload;
//     },
//     setSelectedCustomerId: (state, action) => {
//       state.selectedCustomerId = action.payload;
//     },
//     setSelectedCustomer: (state, action) => {
//   state.selectedCustomer = action.payload;
//   if (action.payload) {
//     state.formData = {
//       ...state.formData,
//       customer_id: action.payload.id?.toString() || '',
//       name: action.payload.name || '',
//       email: action.payload.email || '',
//       phone: action.payload.phone || '',
//       address: action.payload.address || '',
//       gst_number: action.payload.gst_number || '',
//       contact_type: action.payload.contact_type || '',
//       delivery_address: state.sameAsAddress
//         ? action.payload.address || ''
//         : action.payload.delivery_address || state.formData.delivery_address,
//     };
//     state.errors.customer_id = '';
//   }
// },
//     setMode: (state, action) => {
//       state.mode = action.payload;
//     },
//     setSubmitting: (state, action) => {
//       state.submitting = action.payload;
//     },
//     setTotals: (state, action) => {
//       state.totals = action.payload;
//     },
//     setInvoiceStatus: (state, action) => {
//       state.invoiceStatus = action.payload;
//     },
//     setOpenModal: (state, action) => {
//       state.openModal = action.payload;
//     },
//     setOpenAdvance: (state, action) => {
//       state.openAdvance = action.payload;
//     },
//     setOpenOrder: (state, action) => {
//       state.openOrder = action.payload;
//     },
//     setOpenDelivery: (state, action) => {
//       state.openDelivery = action.payload;
//     },
//     setLoading: (state, action) => {
//       state.loading = action.payload;
//     },
//     resetOrderState: () => initialState,
//   },
// });

// export const {
//   setFormData,
//   setErrors,
//   setSameAsAddress,
//   setCustomers,
//   setBranches,
//   setSelectedCustomerId,
//   setSelectedCustomer,
//   setMode,
//   setSubmitting,
//   setTotals,
//   setInvoiceStatus,
//   setOpenModal,
//   setOpenAdvance,
//   setOpenOrder,
//   setOpenDelivery,
//   setLoading,
//   resetForm,
//   resetOrderState,
// } = orderSlice.actions;

// export default orderSlice.reducer;